<template>
  <div v-cloak class="user">
    <div class="user-main">
      <div class="tabs-top">
        <i
          style="color: #ffffff; margin-right: 10px"
          class="el-icon-user-solid"
        ></i>
        <div>个人中心</div>
      </div>

      <el-tabs v-model="activeName" tab-position="left">
        <el-tab-pane label="个人信息" name="0">
          <users></users>
        </el-tab-pane>
        <el-tab-pane label="我的课程" name="1">
          <classs />
        </el-tab-pane>
        <el-tab-pane label="我的需求" name="2">
          <mydemand ref="demand"></mydemand>
        </el-tab-pane>
        <el-tab-pane label="我的收藏" name="3">
          <mycollect ref="demand" v-if="activeName==3"></mycollect>
        </el-tab-pane>
        <el-tab-pane  label="我的活动" name="4">
          <myactivity ref="demand" v-if="activeName==4"></myactivity>
        </el-tab-pane>
        <el-tab-pane label="我的证书" name="5">
          <mycertificate ref="demand"></mycertificate>
        </el-tab-pane>
        <el-tab-pane label="我的考试" name="6">
          <myexam ref="demand"></myexam>
        </el-tab-pane>
        <el-tab-pane label="我的调研" name="7">
          <SurveyList ref="survey"></SurveyList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import users from "../components/User-message.vue";
import mycollect from "../components/mycollect.vue";
import myactivity from "../components/myactivity.vue";
import mycertificate from "../components/mycertificate.vue";
import myexam from "../components/myexam.vue";
import classs from "../components/Class.vue";
import mydemand from "../components/mydemand.vue";
import SurveyList from "../components/Survey-list.vue";
export default {
  name: "User",
  components: {
    users,
    mycollect,
    classs,
    mydemand,
    myactivity,
    mycertificate,
    myexam,
    SurveyList
  },
  data() {
    return {
      activeName: "0",
      zy: false,
      zx: false,
      us: false,
      testlist: [],
    };
  },
  mounted() {
  },

  // 其他页面进来时更新初始数据
  activated() {
    this.activeName='0'
  },
  created() {
    this.$route.query.id ? (this.activeName = '2') : (this.activeName ='0');
  },

  methods: {},
};
</script>

<style lang="scss">
.user {
  min-width: 1200px;
  background: rgba(245, 247, 250, 1);

  .user-main {
    width: 1200px;
    min-height: 900px;
    margin: 0 auto;
    padding-top: 16px;
    box-sizing: border-box;
    padding-bottom: 50px;
    .tabs-top {
      width: 153px;
      height: 37px;
      padding-left: 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-radius: 0px 31px 31px 0px;
      background: #234775;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      position: relative;
      top: 60px;
      z-index: 3;
    }

    .tabs {
      width: 224px;
      height: 456px;
      background: #ffffff;
      padding-top: 17px;
      box-sizing: border-box;
    }

    .el-tabs--left .el-tabs__header.is-left {
      width: 224px;
      height: 456px;
      background: #ffffff;
      padding-top: 88px;
      padding-left: 16px;
      box-sizing: border-box;
    }

    .el-tabs__item:focus.is-active.is-focus:not(:active) {
      box-shadow: 0 0 2px 2px #ffffff inset;
      border-radius: 3px;
    }

    .el-tabs__content {
      // min-height: 600px;
    }

    .el-tabs--left .el-tabs__item.is-left {
      text-align: left;
    }

    .el-tabs--left .el-tabs__item.is-left {
      text-align: left;
    }

    .el-tabs--left .el-tabs__active-bar.is-left {
      left: 0;
      right: auto;
    }

    .el-tabs__nav-wrap::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      // width: 100%;
      // height: 2px;
      background-color: #ffffff;
      z-index: 1;
    }

    .el-tabs__item {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      padding: 0px 56px 0px 0px;
    }

    .is-active {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #234775;
    }

    .el-tabs__active-bar {
      font-weight: bold;
    }

    .el-tabs__active-bar {
      height: 2px !important;
      width: 100%;
      top: 35px;
      background: #234775;
    }

    .tests {
      width: 960px;
      // height: 561px;
      background: #ffffff;
      padding-top: 16px;
      padding-bottom: 161px;
      padding-left: 56px;
      box-sizing: border-box;

      .titles-right {
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 24px;
      }

      .titles-right:before {
        content: "|";
        display: inline-block;
        width: 4px;
        height: 19px;
        background: rgba(15, 117, 189, 1);
        color: rgba(15, 117, 189, 1);
        border-radius: 2px;
        margin-right: 8px;
      }

      .test-lists {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
      }

      .test-children {
        width: 403px;
        // height:132px;
        border-radius: 2px;
        border: 1px solid rgba(186, 202, 221, 1);
        padding: 16px;
        box-sizing: border-box;
        margin-right: 20px;
        margin-bottom: 20px;

        .test-title {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 10px;
        }

        .test-title-detail {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            width: 224px;
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
          }

          span {
            font-size: 20px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: rgba(15, 117, 189, 1);
          }
        }
      }
    }
  }
}
</style>
